<template>
    <div
      :class="[
        'message-item',
        {
          'message-sent': message.isMe,
          'message-received': !message.isMe,
          'message-offset': !message.isMe && isSticker
        }
      ]"
      ref="item"
    >
      <div class="profile" v-if="!message.isMe">
        <svgProfile />
      </div>
      
      <div 
        :class="[
          'bubble',
          {
            'bubble-text': !isSticker,
            'bubble-sticker': isSticker
          }
        ]"
      >
        <template v-if="!isSticker">
          {{message.answer}}
        </template>
        <template v-else>
          <img :src="$getImgUrl(`assets/stickers/${message.stickerCat}/${message.stickerIndex}.webp`)" alt="">
        </template>
    </div>
  </div>
</template>



<script>
import svgProfile from "@/svg/svgProfile"

export default {
  props: {
    message: Object
  },
  mounted() {
    console.log("Message mounted", this.message)
    this.$emit('messageMounted')
    // this.$refs.item.scrollIntoView({
    //   behavior: 'smooth', block: 'end'
    // })
  },
  computed: {
    isSticker() {
      return !this.message.answer && this.message.stickerCat
    }
  },
  components: {
    svgProfile
  }
}

</script>

<style lang="scss" scoped>

.message-item {
  --message-row-gutter-v: 0px;
  --message-row-gutter-h-default: 40px;
  --message-profile-size: 45px;
  --message-row-gutter-h: calc( var(--message-row-gutter-h-default) + var(--message-profile-size) );
  --message-sticker-offset-top: -48px;
  --bubble-gap: 15px;
  --bubble-base-size: 37px;
  --bubble-sticker-width: 120px;

  position: relative;
  display: flex;
  padding: var(--message-row-gutter-v) var(--message-row-gutter-h);
  padding-right: var(--message-row-gutter-h-default);
  @media screen and (max-width: 768px) {
    --message-row-gutter-h: 25px;
  }
  @media screen and (max-width: 540px) {
    --message-row-gutter-h: 11px;
  }
  @media screen and (max-width: 480px) {
    --message-row-gutter-v: 4px;
    --message-row-gutter-h: 10px;
  }
}

.message-sent {
  justify-content: flex-end;
}

.message-offset {
  margin-top: var(--message-sticker-offset-top);
}

.profile {
  position: absolute;
  top: 0%;
  left: var(--message-row-gutter-h-default);
  transform: translate3d(0, calc( (var(--bubble-base-size) - var(--message-profile-size))/2 ), 0);
  width: var(--message-profile-size);
  height: var(--message-profile-size);
  display: flex;
  svg {
    display: block;
    width: 100%;
    margin: auto;
    height: auto;
  }
}

.bubble {
  margin-left: var(--bubble-gap);
}

.bubble-text {
  min-height: var(--bubble-base-size);
  padding: 0 12px;
  background-color: white;
  display: inline-flex;
  align-items: center;
  border-radius: 13px;
  flex: none;
}

.bubble-sticker {
  width: var(--bubble-sticker-width);
  border-radius: 13px;

  img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 13px;

  }
}

</style>